import _ from 'lodash'

export default {
	data() {
		return {
			
		}
	},
	props: [],
	created(){
		
	},
	methods: {
		
	},
	computed:{
		getTotalRecherche(){
			return this.$store.getters.getTotalRecherche
		},
	},
	components:{
		
	}
}